export default (state = [], action) => {
    if(action.type === 'ADD_NOTIFICATION') {
        return state.concat(action.notification)
    }
    if(action.type === 'DISMISS_NOTIFICATION') {
        const index = action.notification ? state.indexOf(action.notification) : action.index
        if(index >= 0 && state.length > index) {
            return state.slice(0, index).concat(state.slice(index + 1, state.length))
        }
    } 
    return state
}


// WEBPACK FOOTER //
// ./reducers/notifications.js